export default "__VITE_ASSET__Bt2FF6g4__"